

import React, { useContext, useEffect, useState } from 'react'
import { CURRENT_URL } from '../../config/runtimeConfig';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar'
import { useNavigate, useParams } from 'react-router-dom';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import FilterIdInput from '../../components/filterIdInput/FilterIdInput';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import { currentStatusEnvois, typeActionsEnvois, typeDeliveries, typeEnvois, typeMovements, typeRamassages, wilayas } from '../../data';
import PageSizeComponent from '../../components/pageSizeComponent/PageSizeComponent';
import TableComponent from '../../components/tableComponent/TableComponent';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent';
import { BagageContext } from '../../context/bagageContext/BagageContext';
import { getBagages } from '../../context/bagageContext/apiCalls';
import Bordlist from '../../components/bordlist/Bordlist';

/*** PDF Import ***/
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { MovementContext } from '../../context/movementContext/MovementContext';
import ModalComponent from '../../components/modalComponent/ModalComponent';
import SubLoadingComponent from '../../components/subLoadingComponent/SubLoadingComponent';
import { AgenceContext } from '../../context/agenceContext/AgenceContext';
import { AuthContext } from '../../context/authContext/AuthContext';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import FormInput from '../../components/formInput/FormInput';
import { getAgencesByWilaya } from '../../context/agenceContext/apiCalls';
import { addMovement } from '../../context/movementContext/apiCalls';
import FormTextArea from '../../components/formTextArea/FormTextArea';

function Bagage() {
    const { dispatch, bagages, isFetching, error, count: pages } = useContext(BagageContext);
    const { user } = useContext(AuthContext);
    const [groupEnvois, setGroupEnvois] = useState([]);
    const [groupRamassage, setGroupRamassage] = useState([]);
    const [bordActive, setBordActive] = useState(false);
    const [typeActionStatus, setTypeActionStatus] = useState(1); // default is Ramassage
    const [movementAmount, setMovementAmount] = useState(0);
    const [ramassageAmount, setRamassageAmount] = useState(0);
    const [isAllowMovement, setIsAllowMovement] = useState(false);

    const { page = 1, id } = useParams();
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);

    const [idEnvoie, setIdEnvoie] = useState("");

    useEffect(() => {
        getBagages(dispatch, pageSize, page, idEnvoie, id,);
        setModalAddActive(false)
    }, [dispatch, pageSize, page, idEnvoie, id])

    useEffect(() => {
        if (bagages.length !== 0) {
            setTypeActionStatus(bagages[0]['type']);
        }
    }, [bagages])

    useEffect(() => {
        if (typeActionStatus === 8 || typeActionStatus === 2 || typeActionStatus === 5 || typeActionStatus === 6) {
            if(user.role === 1 || user.role === 2 || user.role === 3 || user.role === 11){
                setIsAllowMovement(true);
            }
        } else {
            setIsAllowMovement(false);
        }
    }, [typeActionStatus, user])

    useEffect(() => {
        navigate(`/actions/${id}/bagages/1`);
    }, [idEnvoie, id])

    useEffect(() => {
        setRamassageAmount(0);
        groupRamassage.map(item => {
            if (item.count >= 1) {
                setRamassageAmount(prev => {
                    var res = prev * 1 + item.cost * 1;
                    return res.toFixed(2);
                });
            }
        })
    }, [groupRamassage])


    function checkSize(value) {
        if (value.length > 11)
            return value.substring(0, 8) + '...';
        else
            return value;
    }
    function groupEnvoisAddHandle(bagage) {
        let amount = getEnvoieMoney(bagage);
        if (existElementInGroup(groupEnvois, bagage)) {
            setGroupEnvois(prev => prev.filter(item => item.id !== bagage.id));
            setMovementAmount(prev => prev - amount);
            updateRamassageCost(bagage, 'subtraction');
        } else {
            setGroupEnvois(prev => [...prev, bagage])
            setMovementAmount(prev => prev + amount);
            updateRamassageCost(bagage, 'addition');
        }
    }
    function existElementInGroup(list, element) {
        return list.some(item => item.id === element.id)
    }
    // function toutCocher(bagages) {
    //     bagages.map(bagage => {
    //         if (!existElementInGroup(groupEnvois, bagage)) {
    //             let amount = getEnvoieMoney(bagage);
    //             setGroupEnvois(prev => [...prev, bagage]);
    //             setMovementAmount(prev => prev + amount);
    //             updateRamassageCost(bagage, 'addition');
    //         }
    //     })
    // }
    function toutDecocher() {
        setGroupEnvois([]);
        setGroupRamassage([]);
        setMovementAmount(0);
    }
    const getBordereauHandler = async () => {
        if (bagages.length === 0) {
            return
        }
        setBordActive(true);

        const element = document.getElementById('bord-list');
        if (!element) {
            return;
        }
        const canvas = await html2canvas(element, { scale: 3 });
        const data = canvas.toDataURL("image/png");

        const pdf = new jsPDF({
            orientation: "landscape",
            unit: 'px',
            format: "a4"
        })

        const imgProperties = pdf.getImageProperties(data);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

        pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`borderau-livreur.pdf`);
        setBordActive(false);
    }
    function updateRamassageCost(bagage, genre) {
        if (!bagage.Envoi.Entreprise) {
            if (bagage.type === 8) {
                if (bagage.Envoi.typeEnvoie === 1 || bagage.Envoi.typeEnvoie === 2) {
                    if (genre === "addition") {
                        if (groupRamassage.some(element => element.userOwner === bagage.userOwner)) {
                            var gr = groupRamassage.map(item => {
                                if (item.userOwner === bagage.userOwner) {
                                    return { ...item, count: item.count + 1 }
                                }
                                return item
                            })
                            setGroupRamassage(gr);
                        } else {
                            setGroupRamassage(prev => [...prev, { userOwner: bagage.userOwner, cost: bagage.cost, count: 1 }]);
                        }
                    } else if (genre === "subtraction") {
                        var gr = groupRamassage.map(item => {
                            if (item.userOwner === bagage.userOwner) {
                                return { ...item, count: item.count - 1 }
                            }
                            return item
                        })
                        setGroupRamassage(gr);
                    }
                }
            } else if (bagage.type === 5) {
                if (bagage.Envoi.typeEnvoie === 3) {
                    if (genre === "addition") {
                        if (groupRamassage.some(element => element.userOwner === bagage.userOwner)) {
                            var gr = groupRamassage.map(item => {
                                if (item.userOwner === bagage.userOwner) {
                                    return { ...item, count: item.count + 1 }
                                }
                                return item
                            })
                            setGroupRamassage(gr);
                        } else {
                            setGroupRamassage(prev => [...prev, { userOwner: bagage.userOwner, cost: bagage.cost, count: 1 }]);
                        }
                    } else if (genre === "subtraction") {
                        var gr = groupRamassage.map(item => {
                            if (item.userOwner === bagage.userOwner) {
                                return { ...item, count: item.count - 1 }
                            }
                            return item
                        })
                        setGroupRamassage(gr);
                    }
                }
            }
        }
    }
    function getEnvoieMoney(bagage) {
        let res = 0;
        if (bagage.currentStatus === 2 || bagage.currentStatus === 3 || bagage.currentStatus === 4) {  // ACC, RETOUR or ANL in Historical Table
            return res;
        }

        if (typeActionStatus === 8 || typeActionStatus === 2) {
            if (bagage.Envoi.typeEnvoie === 3) {
                res = bagage.Envoi.montant;
            } else {
                if (!bagage.Envoi.Entreprise) {
                    res = bagage.Envoi.cost;
                } else {
                    res = 0;
                }
            }
        } else if (typeActionStatus === 5 || typeActionStatus === 6) {
            if (bagage.Envoi.typeEnvoie === 3) {
                if (!bagage.Envoi.Entreprise) {
                    res = bagage.Envoi.cost;
                } else {
                    res = 0;
                }
            } else {
                res = bagage.Envoi.montant;
            }
        }
        return res * 1;
    }
    function getDepartureOrArrived(bagage) {
        let res = "Arrived";
        if (bagage.currentStatus === 2 || bagage.currentStatus === 3 || bagage.currentStatus === 4) {  // ACC, RETOUR or ANL in Historical Table
            return "Departure";
        }

        if (typeActionStatus === 1 || typeActionStatus === 8 || typeActionStatus === 2) {
            if (bagage.Envoi.typeEnvoie === 3) {
                res = "Arrived";
            } else {
                res = "Departure";
            }
        } else if (typeActionStatus === 5 || typeActionStatus === 6) {
            if (bagage.Envoi.typeEnvoie === 3) {
                res = "Departure";
            } else {
                res = "Arrived";
            }
        }
        return res;
    }


    /**************  Ajouter Modal  **************/
    const { dispatch: dispatchMovement, isFetchingAdd, errorAdd, movement } = useContext(MovementContext);
    const { dispatch: dispatchAgence, agencesByWilaya } = useContext(AgenceContext);

    const [modalAddActive, setModalAddActive] = useState(false);
    const [addType, setAddType] = useState(typeMovements[0]);
    const [addAgence, setAddAgence] = useState({ nom: "Choisir Agence", id: 0, });
    const [addMotif, setAddMotif] = useState("");
    const [addErrorBox, setAddErrorBox] = useState("");

    useEffect(() => {
        if (Object.keys(movement).length !== 0) {
            getBagages(dispatch, pageSize, page, idEnvoie, id,);
            setAddAgence({ nom: "Choisir Agence", id: 0, });
            setModalAddActive(false);
            setAddErrorBox("");

            setGroupEnvois([]);
            setMovementAmount(0);
        }
    }, [movement])

    useEffect(() => {
        getAgencesByWilaya(dispatchAgence);
    }, [])

    useEffect(() => {
        setAddAgence(agencesByWilaya.filter(item => item.id === user.agence)[0]);
    }, [agencesByWilaya])

    useEffect(() => {
        if (errorAdd != false) {
            setAddErrorBox(errorAdd);
            setModalAddActive(true);
        }
    }, [errorAdd])

    const handleAddAction = () => {
        if (addType.id === 0) {
            setAddErrorBox('Vous devez définir le Type');
            return;
        }
        if (addAgence.id === 0) {
            setAddErrorBox("Vous devez définir l'agence");
            return;
        }

        if (groupEnvois.some(item => item.currentStatus === 2 || item.currentStatus === 3)) {
            setAddErrorBox("Une de ces Envois est ACC ou RETOUR");
            return;
        }

        if (typeActionStatus === 8 || typeActionStatus === 2) {
            if (groupEnvois.some(item => item.Envoi.isCostPaid === 1)) {
                setAddErrorBox("Une de ces Envois est déjà payée les frais de départ");
                return;
            }
        } else if (typeActionStatus === 5 || typeActionStatus === 6) {
            if (groupEnvois.some(item => item.Envoi.isDeliveryPaid === 1)) {
                setAddErrorBox("Une de ces Envois est déjà payée les frais d'arrivé");
                return;
            }
        }
        let total = movementAmount * 1 + ramassageAmount * 1;
        isAllowMovement && addMovement(dispatchMovement, addAgence.id, total.toFixed(2), addType.id, typeActionStatus, groupEnvois, addMotif);
    }

    const getTypeClass = (typeCode) => {
        if (typeCode === 1) {
            return "nwe"
        } else if (typeCode === 2) {
            return "livre"
        } else if (typeCode === 3) {
            return "retour"
        } else {
            return "annule"
        }
    }
    const getTypeDelivery = (type) => {
        if (type === 1) {
            return "a-domicile"
        } else if (type === 2) {
            return "en-agence"
        }
    }
    const getTypeEnvoie = (type) => {
        if (type === 1) {
            return "a-accuse"
        } else if (type === 2) {
            return "s-accuse"
        } else if (type === 3) {
            return "pick-up"
        }
    }

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="action" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>
                        {bagages.length !== 0 ? (
                            typeActionsEnvois.filter(item => item.id === typeActionStatus)[0]['nom']
                        ) : ""} :
                    </span>
                </div>

                {
                    error ? <ErrorComponent error={error} /> : (
                        <>
                            <div className="filter">
                                <span className="adv-research">Recherche Avancée</span>
                                <div className="filter-content">
                                    <FilterIdInput placeholder={'ID'} setItem={setIdEnvoie} />
                                </div>
                            </div>

                            {bagages.length !== 0 && (
                                <div className="add-item">
                                    <span className='color-1' onClick={getBordereauHandler}>Sheet</span>
                                    {
                                        isAllowMovement && (
                                            groupEnvois.length === 0 ? (
                                                <span className='color-1' style={{ cursor: 'not-allowed' }}>Encaissement {movementAmount}</span>
                                            ) : (
                                                <span className='color-1' onClick={() => setModalAddActive(true)}>Encaissement ({movementAmount} + {ramassageAmount})</span>
                                            )
                                        )
                                    }
                                    <span className='color-2' onClick={toutDecocher}>Tout décocher </span>
                                </div>
                            )}

                            {
                                isFetching ? <LoadingComponent /> : (
                                    bagages.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span>
                                        : (
                                            <>
                                                <PageSizeComponent pageSize={pageSize} setPageSize={setPageSize} itemLocation={`actions/${id}/bagages`} />
                                                <div className="content">
                                                    {
                                                        <>
                                                            <TableComponent headers={
                                                                isAllowMovement ? ['', groupEnvois.length === 0 ? '' : <span className='mini-th'>{groupEnvois.length}</span>, 'Id', "Expéditeur", "Type d'Envoie", "Type Dépot", "Type Livraison", "Wilaya Départ", "Wilaya d'Arrivé", "Argent", 'Date']
                                                                    : ['', 'Id', "Expéditeur", "Type d'Envoie", "Type Dépot", "Type Livraison", "Wilaya Départ", "Wilaya d'Arrivé", 'Date']
                                                            }>
                                                                {
                                                                    bagages.map((bagage, index) => (
                                                                        <tr key={index} className={existElementInGroup(groupEnvois, bagage) ? 'tr-active' : ''}>
                                                                            <td>
                                                                                {
                                                                                    (bagage.Envoi.dead === 1) && (
                                                                                        <span className="tooltip">
                                                                                            <span className="material-symbols-rounded" style={{ color: "#00c02c" }}>lock</span>
                                                                                            <span className="tooltip-text on">Cette Envoie est terminé</span>
                                                                                        </span>
                                                                                    )
                                                                                }
                                                                                <span className="tooltip">
                                                                                    <span className={["material-symbols-rounded tooltip-icon", bagage.Envoi.isCostPaid === 1 ? 'on' : 'off'].join(' ')} style={{ transform: "scale(1.1)" }}>campaign</span>
                                                                                    {
                                                                                        bagage.Envoi.isCostPaid === 1 ? (
                                                                                            <span className="tooltip-text on">Frais de départ sont payés</span>
                                                                                        ) : (
                                                                                            <span className="tooltip-text off">Frais de départ non encore payés</span>
                                                                                        )
                                                                                    }
                                                                                </span>
                                                                                <span className="tooltip">
                                                                                    <span className={["material-symbols-rounded tooltip-icon", bagage.Envoi.isDeliveryPaid === 1 ? 'on' : 'off'].join(' ')} style={{ transform: "scale(1.1)" }}>campaign</span>
                                                                                    {
                                                                                        bagage.Envoi.isDeliveryPaid === 1 ? (
                                                                                            <span className="tooltip-text on">Frais d'arrivé sont payés</span>
                                                                                        ) : (
                                                                                            <span className="tooltip-text off">Frais d'arrivé non encore payés</span>
                                                                                        )
                                                                                    }
                                                                                </span>
                                                                            </td>
                                                                            {
                                                                                isAllowMovement && (
                                                                                    <td><div className={['mini-rect-div', existElementInGroup(groupEnvois, bagage) ? 'td-active' : ''].join(' ')} onClick={() => groupEnvoisAddHandle(bagage)}></div></td>
                                                                                )
                                                                            }
                                                                            <td>
                                                                                <span className={`table-special ${getTypeClass(bagage.currentStatus)}`}>{currentStatusEnvois.filter(item => item.id === bagage.currentStatus)[0]['nom']}-{bagage.Envoi.tracking}</span>
                                                                            </td>
                                                                            <td>{bagage.Envoi.EntrepriseId ? bagage.Envoi.Entreprise.nom : bagage.Envoi.User.username}</td>
                                                                            <td>
                                                                                <span className={`table-special-border ${getTypeEnvoie(bagage.Envoi.typeEnvoie)}`}>{typeEnvois.filter(item => item.id === bagage.Envoi.typeEnvoie)[0]['nom']}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span className={`table-special ${getTypeDelivery(bagage.Envoi.typeRamassage)}`}>{typeRamassages.filter(item => item.id === bagage.Envoi.typeRamassage)[0]['nom'].slice(6)}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span className={`table-special ${getTypeDelivery(bagage.Envoi.typeDelivery)}`}>{typeDeliveries.filter(item => item.id === bagage.Envoi.typeDelivery)[0]['nom'].slice(10)}</span>
                                                                            </td>
                                                                            <td>{wilayas.filter(item => item.id == bagage.Envoi.wilayaDeparture)[0]['nom']}</td>
                                                                            <td>{wilayas.filter(item => item.id == bagage.Envoi.wilayaArrived)[0]['nom']}</td>
                                                                            {
                                                                                isAllowMovement && (
                                                                                    <td>{(getEnvoieMoney(bagage)).toFixed(2)}</td>
                                                                                )
                                                                            }
                                                                            <td>{bagage.Envoi.createdAt.slice(0, 10)}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </TableComponent>
                                                            {
                                                                (pages > 1) && (<PaginationComponent page={page} pages={pages} item={`actions/${id}/bagages`} />)
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </>
                                        )
                                )
                            }
                        </>
                    )
                }

            </div>


            <div className={bordActive ? 'wrapper-bord active' : 'wrapper-bord'}>
                <div className='content'>
                    <img src={`${CURRENT_URL}//nweblack.png`} />
                    <span className="loader"></span>
                </div>
            </div>
            <div style={{ opacity: "0", position: 'fixed', pointerEvents: 'none' }}>
                {
                    (bagages.length !== 0) && (<Bordlist
                        bagages={bagages} getDepartureOrArrived={getDepartureOrArrived}
                        title={bagages.length !== 0 ? (typeActionsEnvois.filter(item => item.id === typeActionStatus)[0]['nom']) : ""}
                    />)
                }
            </div>


            <ModalComponent modalActive={modalAddActive} setModalActive={setModalAddActive} setErrorBox={setAddErrorBox} title="Ajouter Movement">
                {
                    isFetchingAdd ? <SubLoadingComponent /> : (
                        <form>
                            {addErrorBox !== "" && (<div className='box-error'>{addErrorBox}</div>)}
                            <DropDownComponent data={[{ nom: "Choisir Type", id: 0 }, { nom: "Encaissement", id: 1 }]} itemChoisir={addType} setItemChoisir={setAddType} filter />
                            <DropDownComponent data={[{ nom: "Choisir Agence", id: 0 }, ...agencesByWilaya.filter(item => item.id === user.agence)]} itemChoisir={addAgence} setItemChoisir={setAddAgence} filter />
                            <FormInput label='Montant *' itemInput={movementAmount} setItemInput={setMovementAmount} auth muted inactive />
                            <FormInput label='Supplémentaire *' itemInput={ramassageAmount} setItemInput={setRamassageAmount} auth muted inactive />
                            <FormTextArea label='Motif' itemInput={addMotif} setItemInput={setAddMotif} auth />
                            <div className='button' onClick={handleAddAction}>
                                <span>Valider</span>
                            </div>
                        </form>
                    )
                }
            </ModalComponent>


        </div>
    )
}

export default Bagage
